module.exports = __webpack_public_path__ + "static/img/logo.265448e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/logo.png
// module id = bky1
// module chunks = 1